import { get, post } from './client'

export interface RatioSyncChannel {
  id: number
  name: string
  base_url?: string
  type?: number
}

export interface RatioSyncUpstream {
  id: number
  name: string
  base_url: string
  endpoint: string
}

export interface RatioSyncFetchResult {
  differences?: Record<string, Record<string, RatioSyncDifferenceItem>>
  test_results?: Array<{
    name: string
    status: 'success' | 'error'
    error?: string
  }>
}

export interface RatioSyncDifferenceItem {
  current: unknown
  upstreams: Record<string, unknown>
  confidence?: Record<string, boolean>
}

export async function getRatioSyncChannelsApi(): Promise<RatioSyncChannel[]> {
  return get<RatioSyncChannel[]>('/api/ratio_sync/channels')
}

export async function fetchRatioSyncDiffApi(body: {
  upstreams: RatioSyncUpstream[]
  timeout?: number
}): Promise<RatioSyncFetchResult> {
  return post<RatioSyncFetchResult>('/api/ratio_sync/fetch', body)
}
